import { useState } from "react";
import {
  parseGitHubCommitURL,
  fetchCommitData,
} from "../helper/GetDataFromGithubAPI";
import {
  RFpredictVulnerabilityAllFiles,
  XGpredictVulnerabilityAllFiles,
} from "../helper/PredictionAPI";
import { PredictVulnerabilityResponse } from "../model/PredictResponseModel";
import ReportPage from "./ReportPage";

function MainPage() {
  const [commitLink, setCommitLink] = useState<string>("");
  const [selectedModel, setSelectedModel] = useState("model1");
  const [listFileVulnerability, setListFileVulnerability] = useState<
    PredictVulnerabilityResponse[]
  >([]);

  const handleChange = (e: any) => {
    setCommitLink(e.target.value);
  };

  const handleSubmit = async () => {
    console.log("Submitted commit link:", commitLink);
    try {
      const parsed = parseGitHubCommitURL(commitLink);
      if (!parsed) {
        alert("Invalid GitHub commit URL");
        return;
      }
      const { owner, repo, sha } = parsed;
      const commitData = await fetchCommitData(owner, repo, sha);
      console.log("Fetched commit data:", commitData);
      if (selectedModel === "model2") {
        const response = await XGpredictVulnerabilityAllFiles(commitData);
        setListFileVulnerability(response);
        return;
      }
      console.log("Using Random Forest model");
      const response = await RFpredictVulnerabilityAllFiles(commitData);
      setListFileVulnerability(response);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex flex-col justify-center items-center px-8">
      <div className="w-full max-w-6xl">
        {!listFileVulnerability || listFileVulnerability.length === 0 ? (
          <>
            <div className="text-4xl font-bold text-center mb-20 text-green-400 font-mono tracking-wider">
              [ Commit Vulnerability Predictor ]
            </div>

            <div className="space-y-8">
              <div>
                <label className="block text-green-400 font-mono text-lg mb-2 uppercase">
                  &gt; Commit URL
                </label>
                <input
                  type="text"
                  value={commitLink}
                  onChange={handleChange}
                  placeholder="https://github.com/..."
                  className="w-full  text-lg px-4 py-3 bg-black border border-green-500  rounded font-mono focus:outline-none focus:border-green-300"
                />
              </div>

              <div>
                <label className="block text-green-400 font-mono text-lg mb-2 uppercase">
                  &gt; Detection Machine Learning Model
                </label>
                <div className="relative">
                  <select
                    className="appearance-none w-full px-4 py-3 text-lg  bg-black border border-green-500 text-white rounded focus:outline-none focus:border-green-300 cursor-pointer"
                    value={selectedModel}
                    onChange={(e) => setSelectedModel(e.target.value)}
                  >
                    <option value="model1">Random Forest</option>
                    <option value="model2">XGBoost</option>
                  </select>
                  <div className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-green-400">
                    ▼
                  </div>
                </div>
              </div>

              <div className="flex justify-center">
                <button
                  onClick={handleSubmit}
                  className="w-[200px] text-lg px-6 py-3 bg-green-500 text-black font-mono font-bold rounded hover:bg-green-400 transition-colors uppercase"
                >
                  [ SCAN ]
                </button>
              </div>

              <div className="mt-16 border border-green-500/30 p-6 rounded">
                <div className="font-mono text-lg space-y-2">
                  <div className="text-green-400 mb-3">&gt; SYSTEM INFO:</div>
                  <div>• Public GitHub repositories only</div>
                  <div>• Supported: .py .ts .js .go .tsx file extensions</div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <ReportPage
            listFileVulnerability={listFileVulnerability}
            setListFileVulnerability={setListFileVulnerability}
          />
        )}
      </div>
    </div>
  );
}

export default MainPage;
